/*
 * File: App.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 3:20:12 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { BackTop, Layout } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import { Loader } from 'components/atoms/Loader';
import { PageHeader } from 'components/common/PageHeader';
import { PageSubHeader } from 'components/common/PageSubHeader';
import { useAuthentication } from 'hooks/useAuthentication';
import Cookies from 'js-cookie';
import { AcuityContextModel } from 'models/AcuityContextModel';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setAcuityContext } from 'redux/slices/appSlice';
import { useAppSelector } from 'redux/store';
import { MainRoutes } from 'routes/MainRoutes';
import { InlineStylesModel } from '../models/InlineStylesModel';

const { Content } = Layout;
const styles: InlineStylesModel = {
  layout: {
    height: '100vh'
  },
  header: {
    lineHeight: 1,
    display: 'flex',
    justifyContent: 'center'
  },
  content: {
    padding: window.screen.width < 420 ? '20px 10px' : '10px 50px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1920,
    alignSelf: 'center',
    width: '100%'
  },
  somethingWrong: {
    textAlign: 'center',
    height: '100vh'
  }
};

export const App = (): JSX.Element => {
  const { accessToken, isLoading } = useAuthentication();
  const { user, acuityContext } = useAppSelector((state) => state.app);
  const isMdsiEmployee = user ? user['https://acuity.mdsiinc.com/user/user_metadata'].is_mdsi_employee : null;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const cookie = Cookies.get(`${process.env.REACT_APP_COOKIE_PREFIX}_acuity_context`);

  const isSubheaderHidden = Boolean(pathname.includes('/about') || pathname.includes('/release-notes') || pathname.includes('/profile'));

  // if (!cookie) {
  //   window.location.href = 'www.google.com';
  // }
  // TO SET COOKIE TO REDUX
  useEffect(() => {
    const cookieJSON: AcuityContextModel = cookie ? JSON.parse(cookie) : undefined;

    // Set cookie
    if (cookieJSON?.selectedCustomer && accessToken) {
      dispatch(setAcuityContext(cookieJSON));
    }

    // if (accessToken && !cookieJSON && pathname.includes('/internal') && !isMdsiEmployee) window.location.href = process.env.REACT_APP_ERNIE_REDIRECT_URL;
  }, [accessToken, cookie, isMdsiEmployee, pathname]);

  // useEffect(() => {
  //   // Only Run after access token is ready
  //   if (!accessToken) return;
  //   /*
  //     1. Mdsi Employee clicks internal link -> internal page regardless of cookies
  //     2. Mdsi Employee click customer Link -> go root route and then redirect to customer
  //     3. Mdsi Employee can go back to customers by nav item

  //     1. customer click customer link -> go to root route then redirect to customer and no nav link

  //   */

  //   // nav(`/${cookieJSON.selectedCustomer.id}/projects`);
  //   // Came fomr Internal App Link
  //   if (isMdsiEmployee && pathname.includes('/internal')) return;

  //   // "/"
  //   // if (acuityContext) nav(`/${acuityContext.selectedCustomer.id}/projects`);
  // }, [acuityContext, accessToken]);

  if (isLoading || accessToken === null) {
    return <Loader message={undefined} fullPageLoader />;
  }

  return (
    <React.StrictMode>
      <Layout style={styles.layout}>
        <BackTop />
        <Header style={styles.header}>
          <PageHeader />
        </Header>
        {isSubheaderHidden ? null : <PageSubHeader />}
        <Content style={styles.content}>
          <MainRoutes />
        </Content>
      </Layout>
    </React.StrictMode>
  );
};
